import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CodigoCuentaFormGroup = ({ iError, iTouched, fIsSubmitting, vPrefijo, vNivel }) => {
  return (
    <Form.Group>
      <Form.Label text='PLAN CONTABLE' htmlFor='input-sufijoCodigoCuenta' md={4} />
      <Col md={3} className='col-prefijoCodigoCuenta'>
        <Form.InputText disabled id='input-prefijoCodigoCuenta' defaultValue={vPrefijo} />
      </Col>
      <Col md={5}>
        <Field name='sufijoCodigoCuenta'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting || vNivel === 1}
              id='input-sufijoCodigoCuenta'
              placeholder='Ingresar código cuenta ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoCuentaFormGroup)
